module.exports = __webpack_public_path__ + "img/ciclogo.405e4685.png";